import { Add, DeleteOutline } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Button } from "../Button";
import { Grid } from "../Grid";
import { Input } from "../Input";
import { Typography } from "../Typography";

export type OrderPassengerFormValue = {
  name: string;
  surname: string;
};

type OrderPassengersEditorProps = {
  passengers: OrderPassengerFormValue[];
  onChange: (next: OrderPassengerFormValue[]) => void;
  disabled?: boolean;
  error?: string;
};

export const OrderPassengersEditor = ({
  passengers,
  onChange,
  disabled,
  error,
}: OrderPassengersEditorProps) => {
  const safePassengers = passengers.length
    ? passengers
    : [{ name: "", surname: "" }];

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography fontWeight="bold">Passageiros</Typography>
      </Grid>

      {safePassengers.map((passenger, index) => (
        <Grid item xs={12} key={`passenger-${index}`}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={5}>
              <Input
                label="Nome"
                value={passenger.name}
                disabled={disabled}
                onChange={(event) => {
                  const next = [...safePassengers];
                  next[index] = { ...next[index], name: event.target.value };
                  onChange(next);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <Input
                label="Sobrenome"
                value={passenger.surname}
                disabled={disabled}
                onChange={(event) => {
                  const next = [...safePassengers];
                  next[index] = { ...next[index], surname: event.target.value };
                  onChange(next);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2} textAlign="center">
              <IconButton
                disabled={disabled || safePassengers.length <= 1}
                onClick={() => {
                  const next = safePassengers.filter((_, idx) => idx !== index);
                  onChange(next.length ? next : [{ name: "", surname: "" }]);
                }}
              >
                <DeleteOutline />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      ))}

      <Grid item xs={12}>
        <Button
          variant="outlined"
          disabled={disabled}
          onClick={() => onChange([...safePassengers, { name: "", surname: "" }])}
        >
          <Add sx={{ mr: 1 }} />
          Adicionar passageiro
        </Button>
      </Grid>

      {error ? (
        <Grid item xs={12}>
          <Typography color="error">{error}</Typography>
        </Grid>
      ) : null}
    </Grid>
  );
};
